import { DevicesProcessor, AppInstancesProcessor } from 'common/repositoryProcessors/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import log from 'common/services/logging/loggers';
import { AppIntegrationsRepository, LicensesRepository } from 'common/repositories/index';
import { isVisible, hasEssentialProps, hasUnsupportedBrowsers } from './productFilters';
import Alert from '../../../../../directives/dashboard/ui-alert/-RFC.ui-alert-logic';
/* eslint no-unneeded-ternary: 0 */
/* eslint array-callback-return: 0 */

const currentDeviceOS = window.deviceOs;
const _devicesWithoutAppInstalled = {};

/**
 * Products
 */
angular.module('controllers')
    .controller('Products', ($scope, $state, Util, $window, DeployRestService) => {

        $scope.browserName = $window.browserName.toLowerCase();
        $scope.unsupportedApps = CWCONFIG.hiddenAppInBundle || [];
        $scope.currentDeviceOS = currentDeviceOS;
        $scope.isWindowsOS = !!(currentDeviceOS.toLowerCase().indexOf('windows') > -1);
        $scope.language = CWCONFIG.language === 'de' ? 'de' : null;
        $scope.brandName = CWCONFIG.partnerConfig.name;

        const isBrowserExtension = (app) => {

            const platformList = Util.deepFind(app, 'attributes.platform.type') || Util.deepFind(app, 'attributes.custom.manifest.os');
            if (!platformList) {

                return false;

            }
            if (platformList.indexOf('browser') !== -1 || platformList.indexOf('webapp') !== -1) {

                return true;

            }
            return false;

        };
        const isIOTApps = (app) => {

            if (Util.deepFind(app, 'attributes.custom.manifest.id') === 'iot') {

                return true;

            }

            return false;

        };
        $scope.apps = filterProducts(AppIntegrationsRepository.getAll());
        $scope.browserExtensions = $scope.apps.filter(isBrowserExtension);
        $scope.mobileApps = $scope.apps.filter(app => app.attributes.platform.type.find(os => os === 'android' || os === 'ios'));
        $scope.iotApps = $scope.apps.filter(isIOTApps);


        // assign a proper FSS banner's title and download bundle based on user's subscription
        let defaultDeployedAppId;
        if ($scope.isWindowsOS) {

            defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.windows || 'sptl1';

        } else if (currentDeviceOS === 'mac_os_x') {

            defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.osx || 'fass0';

        }

        const licensesRepo = LicensesRepository.getAll();

        const hasPrime = appId =>
            !!(licensesRepo.find(license => appId === license.relationships.app.data.id
                && license.attributes.expired === false));

        if (hasPrime('aps20')) {

            defaultDeployedAppId = 'aps20';

        } else if (hasPrime('aps10')) {

            defaultDeployedAppId = 'aps10';

        } else if (hasPrime('aps30')) {

            defaultDeployedAppId = 'aps30';

        }
        $scope.featureApp = AppIntegrationsRepository.getById(defaultDeployedAppId) || {};

        const appName = AppIntegrationsRepository.getAppName(defaultDeployedAppId) || '';

        $scope.featureAppTitle = licensesRepo.length === 0
            ? appName
            : `${$scope.brandName} ${appName.replace(/free/i, '')}`;

        // if default appId is SPTL1 we offer FASS0 app intergrations instead
        const AppIntegrations = defaultDeployedAppId === 'sptl1'
            ? AppIntegrationsRepository.getById('fass0')
            : AppIntegrationsRepository.getById(defaultDeployedAppId);

        let appComponents = [];
        const includedApps = Util.deepFind(AppIntegrations, 'relationships.apps') || {};
        if (includedApps.data) {

            includedApps.data.forEach((app) => {

                if (!$scope.unsupportedApps.find(id => app.id === id) &&
                    AppIntegrationsRepository.getById(app.id) !== undefined) {

                    appComponents.push(AppIntegrationsRepository.getById(app.id));

                }

            });

        }
        // sort app components by category
        $scope.servicesByCategory = {
            security: [],
            privacy: [],
            performance: [],
        };
        appComponents = appComponents.filter(hasUnsupportedBrowsers(Util, $scope));
        appComponents.forEach((integration) => {

            // e.g. antivirus
            const serviceName = integration.attributes.prototype ||
                integration.attributes.service;

            const category = CWCONFIG.servicesByCategory[serviceName];

            if (category) {

                $scope.servicesByCategory[category].push(integration);

            }

        });


        // we go through each product and we apply two sequential filters
        // we show items that pass both filters, both only log items that don't pass the second
        function filterProducts(products) {

            const filteredProducts = [];
            const hiddenProducts = [];

            const essentialProps = hasEssentialProps(hiddenProducts);

            /**
             * Remove browser extensions if the current browser is not compatible with the extension
             */
            const unsupportedBrowsers = hasUnsupportedBrowsers(Util, $scope);

            products
                .filter(isVisible)
                .filter(essentialProps)
                .filter(unsupportedBrowsers)
                .map((product) => {

                    // Password Manager is a webapp, so we add Windows & OSX in order
                    // to show it when these filters are selected
                    if (product.attributes.platform.type.length === 1 &&
                        product.attributes.platform.type[0] === 'webapp') {

                        Array.prototype.push.apply(product.attributes.platform.type, ['windows', 'osx']);

                        product.devices = DevicesProcessor.getDevicesByApp(product);

                    }

                    const serviceName = product.attributes.prototype ||
                        product.attributes.service;

                    // compatible devices that have the product installed
                    product.devices = DevicesProcessor.getDevicesByApp(product).filter((device) => {

                        const productOs = Util.deepFind(product, 'attributes.platform.type');
                        if (productOs) {

                            return productOs.indexOf(device.attributes.os) > -1;

                        }

                        return false;

                    });
                    product.mobileDevices = product.devices.filter(device => device.attributes.os === 'android' || device.attributes.os === 'ios');

                    // add 'category' property
                    product.category = CWCONFIG.servicesByCategory[serviceName];

                    product.buttonLabel = getButtonLabel(product);

                    filteredProducts.push(product);

                });

            if (hiddenProducts.length > 0) {

                log.log({
                    type: 'Product Catalog - free products that are hidden',
                    cmd: '',
                    data: hiddenProducts,
                });

            }

            return filteredProducts;

        }

        Mixpanel.send('ConnectWeb Free Products Open', {
            Source: 'Direct',
        });

        /**
         * Shows details of a product
         * @param {Object} app The object of the product
         */
        $scope.showDetails = (app) => {

            Mixpanel.send('ConnectWeb Learn More Click', {
                Page: 'Free Products',
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

            $state.go('root.dashboard.products.ltb.activate', {
                ltb: 'activate',
                resourceId: app.id,
            });

        };

        // direct binding for devices
        const devicesObservable = DevicesProcessor.getObservable();
        const onNextDevice = () => {

            $scope.apps.forEach((app, index) => {

                $scope.apps[index].buttonLabel = getButtonLabel(app);

            });

            filterProducts($scope.apps);

        };
        const devicesSubscriber =
            devicesObservable.subscribe(onNextDevice, () => {}, () => {});

        // direct binding for app-instances
        const appInstancesObservable = AppInstancesProcessor.getObservable();
        const onNextAppInstance = () => {

            $scope.apps.forEach((app, index) => {

                $scope.apps[index].buttonLabel = getButtonLabel(app);

            });

            filterProducts($scope.apps);

        };

        const appInstancesSubscriber =
            appInstancesObservable.subscribe(onNextAppInstance, () => {}, () => {});

        /**
         * Checks if the app is compatible with the user devices and if it's already installed
         * Returns activate if can be deployed or install if there is no
         * @param {Object} app
         */
        function getButtonLabel(app) {

            // Webapp
            const productUrl = Util.deepFind(app, 'attributes.custom.manifest.product_url');

            if (productUrl) {

                return 'open';

            } else if (app.devices.length > 0) {

                return 'install_other';

            }
            // the install btn for Home Guard should always be 'install_other'
            // because we allow users to download only android version from product page
            if (app.id === 'ashs0') {

                return 'install_other';

            }

            return 'install';

        }

        /**
         * @param {Object} app The app object
         */
        $scope.installService = (app, installType) => {

            let stateName = $state.current.name;
            // check whether we can deploy the product on the current device
            const matchingOS = DevicesProcessor.getDeployOSfor(app.id, currentDeviceOS) || null;
            const hasMatchingOS = !!matchingOS;

            Mixpanel.send('ConnectWeb Install Click', {
                Page: 'Free Products',
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

            if (stateName.indexOf('.ltb.deploy') === -1) {

                stateName += '.ltb.deploy';

            }

            // install on other device
            if (installType === 'other_device') {

                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    resourceId: app.id,
                    deployType: 'other',
                }, {
                    reload: false,
                });

            } else {

                // normal install
                $state.go(stateName, {
                    ltb: 'deploy',
                    deviceId: 'new',
                    resourceId: app.id,
                    os: matchingOS,
                    autoInstall: hasMatchingOS,
                }, {
                    reload: false,
                });

            }

        };

        /**
         * @param {Object} app The app object
         */
        $scope.openServiceLink = (app) => {

            Mixpanel.send('ConnectWeb Open Click', {
                Page: 'Free Products',
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

            window.open(app.attributes.custom.manifest.product_url, '_blank');

        };

        /**
         * @param {String} extensionId The extension id for Opera
         * @param {String} appId The app integration id
         */
        $scope.installOperaExtension = (extensionId, appId) => {

            const operaObj = $window.opr || {};

            if (operaObj.addons) {

                operaObj.addons.installExtension(extensionId);

            } else {

                let extensionUrl = CWCONFIG.operaExtensions[appId];
                extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

                $window.open(extensionUrl, '_blank');

            }

        };

        /**
         * @param {Object} app The app integration object
         */
        $scope.sendMixpanelEvent = (app) => {

            Mixpanel.send('ConnectWeb Install Click', {
                Page: 'Free Products',
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

        };
        $scope.sendMixpanelEventDetailsButton = (app, label) => {

            Mixpanel.send('ConnectWeb Product Page Details Click', {
                Page: 'Free Products',
                Label: label,
                Product: Util.deepFind(app, 'attributes.resource.oeName'),
                'Product ID': app.id,
            });

        };

        /**
         * @param {Object} app The app integration object
         */
        $scope.deploy = (app) => {

            let deployState;

            _devicesWithoutAppInstalled[app.id].forEach((device) => {

                // set the last deploy type, priority has the offline deploy
                const deviceState = Util.deepFind(device, 'attributes.state');
                if (!deployState) {

                    deployState = {
                        type: (deviceState === 'online') ? 'online' : 'offline',
                        device,
                    };

                } else if (deployState && deviceState !== 'online') {

                    deployState = {
                        type: 'offline',
                        device,
                    };

                }

                const deploymentPayload = {
                    deviceId: device.id,
                    userId: Util.deepFind(device, 'relationships.user.data.id'),
                    appId: app.id,
                };

                DeployRestService
                    .deployOnDevice(deploymentPayload)
                    .then((response) => {

                        log.debug('Products -> DeployRestService success', deploymentPayload, response);

                    })
                    .then(null, (e) => {

                        // 409 === Conflict
                        // An instance for this application already exists (pending)
                        // Do not hide the modal
                        if (e.status === 409) {

                            return;

                        }

                        log.debug('Products -> DeployRestService error', deploymentPayload, e);

                        Alert.error({
                            message: 'cw.modal.server-error.desc',
                            icon: {
                                cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,
                            },
                        });

                    });

            });

            // Open the deploy modal for the last device set in the deployState variable
            $state.go('root.dashboard.products.ltb.deploy', {
                ltb: 'deploy',
                resourceId: deployState.device.id,
                appId: app.id,
            }, {
                reload: false,
            });

        };

        $scope.$on('$destroy', () => {

            devicesSubscriber.dispose();
            appInstancesSubscriber.dispose();

        });

    });



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/products/products.js